import useStore from '../../../store';

// --- Константы ---
const PIECE_HIT_AREA_FACTOR = 1.5; // Увеличение области клика
const PIECE_HIT_VERTICAL_COMPENSATION = 0; // Компенсация вертикального смещения для клика


function getTargetAtPosition(pos, store) {
    const { ref } = store;
    const { puzzle } = ref;
    const { state, config, boardTransform } = puzzle;

    if (!state.isInitialized) return null;

    const hitPos = { ...pos, y: pos.y - PIECE_HIT_VERTICAL_COMPENSATION };

    const boardX = pos.x;
    const boardY = pos.y;
    const hitBoardY = hitPos.y;

    const onBoardPieces = Object.entries(state.pieces)
        .filter(([id, p]) => p && (p.onBoard || p.placed) && state.draggingPiece?.pieceId !== id)
        .sort(([, pA], [, pB]) => (pB.zIndex ?? 30) - (pA.zIndex ?? 30));

    for (const [pieceId, piece] of onBoardPieces) {
        if (!piece.currentPos || !piece.baseDimensions) continue;

        const displayWidth = piece.baseDimensions.width * state.imageScale * boardTransform.scale;
        const displayHeight = piece.baseDimensions.height * state.imageScale * boardTransform.scale;
        const pLeft = piece.currentPos.x * boardTransform.scale;
        const pTop = piece.currentPos.y * boardTransform.scale;

        const hitWidth = displayWidth * PIECE_HIT_AREA_FACTOR;
        const hitHeight = displayHeight * PIECE_HIT_AREA_FACTOR;
        const hitX = pLeft - (hitWidth - displayWidth) / 2;
        const hitY = pTop - (hitHeight - displayHeight) / 2;

        if (boardX >= hitX && boardX <= hitX + hitWidth &&
            hitBoardY >= hitY && hitBoardY <= hitY + hitHeight)
        {
            const offset = {
                x: boardX - pLeft,
                y: boardY - pTop,
            };
            // TODO: Точная проверка формы куска
            return { type: 'piece', pieceId, offset };
        }
    }
    return null;

}


// --- Основная функция установки слушателей ---
export function setupCanvasPointerListeners(canvasElement, store) {
    const { ref } = store;
    const { puzzle } = ref;

    if (puzzle.pointerListenersAreSet) return;
    puzzle.pointerListenersAreSet = Date.now();


    const methods = puzzle.methods;

    const getCanvasPosition = (event, element) => {
        if (!element) return { x: 0, y: 0 };
        const rect = element.getBoundingClientRect();
        let actualX = event.clientX - rect.left;
        let actualY = event.clientY - rect.top;
        return { x: actualX, y: actualY };
    };

    // === Обработчик pointerdown (на конкретном canvas) ===
    const handlePointerDown = (event) => {

      // Не прерываем, если это второй палец для вращения
      if (puzzle.state.draggingPiece) {
            // Потенциальное начало вращения вторым пальцем - не устанавливаем новый currentPointerId
            if (puzzle.config.game.pieceRotation) {
              methods.rotateDraggingPiece(event); 
            }
            event.preventDefault();
            event.stopPropagation();
            return;
      }

      useStore.setState({ pointerPosition: { x: event.clientX, y: event.clientY } });

      if (!event.target.classList.contains('puzzle-board')) {
        return
      }

      const boardRect = canvasElement.getBoundingClientRect();
      if (event.clientX < boardRect.left || event.clientX > boardRect.right ||
          event.clientY < boardRect.top || event.clientY > boardRect.bottom) {
          return; // Выходим, если клик не на нашем основном канвасе
      }

      const pos = getCanvasPosition(event, canvasElement);
      puzzle.temp.canvasPosition = { x: pos.x, y: pos.y };

      const target = getTargetAtPosition(pos, store); // activeCanvasType уже установлен
      if (!target) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (target.type === 'piece') {
          const piece = puzzle.state.pieces[target.pieceId];
          // Проверяем, можно ли взять кусок
          if (!piece.placed && (!piece.reservedUntil || piece.reservedUntil <= Date.now() || piece.reservedBy === ref.telegram?.activeUserId)) {
              // Передаем 'board' или 'tray' как dragOrigin
              methods.startDragging(target.pieceId, event, target.offset, 'board');
          } 
      } 
    };

    // === Обработчик pointermove (на document) ===
    const handlePointerMove = (event) => {

      if (puzzle.state.draggingPiece && puzzle.state.draggingPiece.pointerId !== event.pointerId) {
        return;
      }

      useStore.setState({ pointerPosition: { x: event.clientX, y: event.clientY } });


    };

    // === Обработчик pointerup / pointercancel (на document) ===
    const handlePointerUpOrCancel = (event) => {
        // event.preventDefault(); // Не всегда нужно
        // event.stopPropagation(); // Не всегда нужно
        const draggingPiece = puzzle.state.draggingPiece;
        if (!draggingPiece) { return; }

        methods.stopDragging(event);

    };


    // === Отключение контекстного меню (на document) ===
    const handleContextMenu = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };


    // --- Добавление слушателей ---
    // Эти остаются на конкретном элементе
    // document.addEventListener('pointerdown', handlePointerDown); <-- Убираем
    document.addEventListener('pointerdown', handlePointerDown); // <-- Добавляем

    // Эти переезжают на document
    document.addEventListener('pointermove', handlePointerMove);
    document.addEventListener('pointerup', handlePointerUpOrCancel);
    document.addEventListener('pointercancel', handlePointerUpOrCancel);
    document.addEventListener('contextmenu', handleContextMenu);

    // Возвращаем функцию очистки
    return () => {
        canvasElement.removeEventListener('pointerdown', handlePointerDown);

        document.removeEventListener('pointermove', handlePointerMove);
        document.removeEventListener('pointerup', handlePointerUpOrCancel);
        document.removeEventListener('pointercancel', handlePointerUpOrCancel);
        document.removeEventListener('contextmenu', handleContextMenu);

        puzzle.pointerListenersAreSet = null;

    };
}